"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _MessageCard = _interopRequireDefault(require("../../components/Cards/MessageCard"));
var _NumberInput = _interopRequireDefault(require("../../components/TextFields/NumberInput"));
var _Button = _interopRequireDefault(require("../../components/Button"));
var _Text = _interopRequireDefault(require("../../components/Text"));
var _StepCompletionNotif = _interopRequireDefault(require("../../components/Modals/StepCompletionNotif"));
var _Loader = _interopRequireDefault(require("../../components/Loader"));
var _FormModal = _interopRequireDefault(require("../../components/Modals/FormModal"));
var _DateInput = _interopRequireDefault(require("../../components/TextFields/DateInput"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var Services = _interopRequireWildcard(require("../../services"));
var _colors = _interopRequireDefault(require("../../theme/colors"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CommissionsForm = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(CommissionsForm, _Component);
  function CommissionsForm() {
    var _this;
    (0, _classCallCheck2["default"])(this, CommissionsForm);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, CommissionsForm, [].concat(args)), _this.state = {
      life: 0,
      add: 0,
      ltd: 0,
      std: 0,
      depLife: 0,
      ci: 0,
      dental: 0,
      health: 0,
      outOfCountry: 0,
      stopLoss: 0,
      hsa: 0,
      lsa: 0,
      efap: 0,
      virtualHealthcare: 0,
      setForAll: 0,
      successDialogOpen: false,
      effectiveDate: dates.getUTC(new Date(), 'YYYY/MM/DD'),
      showEffectiveDateDialog: false
    }, _this._validateEffectiveDate = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var effectiveDateError, startOfMonth, effectiveDateUTC;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Services.validateInput('effectiveDate', _this.state.effectiveDate);
          case 2:
            effectiveDateError = _context.sent;
            startOfMonth = dates.getStartOfMonth();
            effectiveDateUTC = dates.getUTC(_this.state.effectiveDate);
            if (effectiveDateUTC < startOfMonth) {
              effectiveDateError = _i18n["default"].t(_tokens["default"].labels.advisor.commissionsCanOnlyBeBackdated);
            }
            _context.next = 8;
            return _this.setState({
              effectiveDateError: effectiveDateError
            });
          case 8:
            if (!effectiveDateError) {
              _context.next = 10;
              break;
            }
            return _context.abrupt("return", false);
          case 10:
            return _context.abrupt("return", true);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), _this._handleChange = function (key, value) {
      _this.setState((0, _defineProperty2["default"])({}, key, value));
    }, _this._setGlobal = function (value) {
      _this.setState({
        setForAll: value,
        life: value,
        add: value,
        ltd: value,
        std: value,
        depLife: value,
        ci: value,
        dental: value,
        health: value,
        outOfCountry: value,
        stopLoss: value,
        hsa: value,
        lsa: value,
        efap: value,
        virtualHealthcare: value
      });
    }, _this._toggleEffectiveDateDialog = function () {
      _this.setState({
        showEffectiveDateDialog: !_this.state.showEffectiveDateDialog
      });
    }, _this._save = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var effectiveDateValid, effectiveDate, data, success;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!_this.props.isMasterSite && _this.props.currentAccountMeta.state > 3)) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", null);
          case 2:
            _context2.next = 4;
            return _this._validateEffectiveDate();
          case 4:
            effectiveDateValid = _context2.sent;
            if (effectiveDateValid) {
              _context2.next = 7;
              break;
            }
            return _context2.abrupt("return", null);
          case 7:
            effectiveDate = dates.getUTC(_this.state.effectiveDate);
            data = _objectSpread({}, _this.state);
            delete data.effectiveDate;
            delete data.setForAll;
            delete data.successDialogOpen;
            delete data.showEffectiveDateDialog;
            delete data.effectiveDateError;
            _context2.next = 16;
            return _this.props.saveCommissions(_this.props.currentAccountMeta.accountID, data, effectiveDate);
          case 16:
            success = _context2.sent;
            if (success) {
              _this.setState({
                effectiveDate: dates.getUTC(new Date(), 'YYYY/MM/DD'),
                showEffectiveDateDialog: false
              });
            }
            return _context2.abrupt("return", null);
          case 19:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), _this._submit = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var data, success;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            data = _objectSpread({}, _this.state);
            delete data.setForAll;
            delete data.successDialogOpen;
            delete data.effectiveDate;
            delete data.showEffectiveDateDialog;
            delete data.effectiveDateError;
            _context3.next = 8;
            return _this.props.submitCommissions(_this.props.currentAccountMeta.accountID, data);
          case 8:
            success = _context3.sent;
            if (!(success && _this.props.isRevision)) {
              _context3.next = 12;
              break;
            }
            _this.props.setSelectedSection("revision-plan-pricing");
            return _context3.abrupt("return", null);
          case 12:
            if (success) {
              _this.setState({
                successDialogOpen: true
              });
            }
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })), _this._closeSuccessDialog = function () {
      _this.setState({
        successDialogOpen: false
      });
    }, _this._goToNextStep = function () {
      // refresh the page to get the latest changes and move back to dashboard
      window.location.reload();
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _createClass2["default"])(CommissionsForm, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var commissions;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.props.getCommissions(this.props.currentAccountMeta.accountID);
            case 2:
              commissions = _context4.sent;
              if (commissions) {
                this.setState(_objectSpread({}, commissions));
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }() // eslint-disable-next-line consistent-return
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var styles = {
        contentBlock: {
          backgroundColor: _colors["default"].surface,
          boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
          display: 'block',
          margin: 'auto auto 30px auto',
          padding: '30px',
          position: 'relative',
          zIndex: 3
        }
      };
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !this.props.isMasterSite && this.props.currentAccountMeta.status === 1 && !this.props.isRevision ? /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].titles.commissionsBreakdown),
        subtitle: _i18n["default"].t(_tokens["default"].labels.advisor.viewCommissionsInstructions),
        btn: false
      }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !this.props.isMasterSite && this.props.currentAccountMeta.state > 3 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "red"
      }, _i18n["default"].t(_tokens["default"].labels.advisor.commissionsChangeNotice)), this.props.isMasterSite && !this.props.isQuote && !this.props.isRevision ? /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].titles.commissionAssignment),
        subtitle: _i18n["default"].t(_tokens["default"].labels.advisor.setCommissionRatesInstructions)
      }) : /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].titles.commissionAssignment),
        subtitle: _i18n["default"].t(_tokens["default"].labels.advisor.finalizeCommissionRatesInstructions),
        btn: this.props.isQuote && this.props.currentAccountMeta.state <= 1 || this.props.isRevision && this.props.step <= 1,
        btnName: _i18n["default"].t(_tokens["default"].buttons.submit),
        btnOnClick: this._submit
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.contentBlock
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        bold: true,
        display: "block"
      }, _i18n["default"].t(_tokens["default"].labels.advisor.setAll), ":"), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        sx: {
          width: '24.5%',
          minWidth: 200
        }
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].titles.commissions),
        fullWidth: true,
        suffix: "%",
        value: this.state.setForAll || 0,
        onChange: function onChange(e) {
          return _this2._setGlobal(e.target.value);
        },
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        bold: true,
        display: "block",
        margin: "20px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.advisor.setIndividually), ":"), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].titles.lifeInsurance),
        fullWidth: true,
        suffix: "%",
        value: this.state.life || 0,
        onChange: function onChange(e) {
          return _this2._handleChange("life", e.target.value);
        },
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].titles.accidentalDeathAndDismemberment),
        fullWidth: true,
        suffix: "%",
        value: this.state.add || 0,
        onChange: function onChange(e) {
          return _this2._handleChange("add", e.target.value);
        },
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].titles.longTermDisability),
        fullWidth: true,
        suffix: "%",
        value: this.state.ltd || 0,
        onChange: function onChange(e) {
          return _this2._handleChange("ltd", e.target.value);
        },
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].titles.shortTermDisability),
        fullWidth: true,
        suffix: "%",
        value: this.state.std || 0,
        onChange: function onChange(e) {
          return _this2._handleChange("std", e.target.value);
        },
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].titles.dependentLife),
        fullWidth: true,
        suffix: "%",
        value: this.state.depLife || 0,
        onChange: function onChange(e) {
          return _this2._handleChange("depLife", e.target.value);
        },
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].titles.criticalIllness),
        fullWidth: true,
        suffix: "%",
        value: this.state.ci || 0,
        onChange: function onChange(e) {
          return _this2._handleChange("ci", e.target.value);
        },
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].titles.dental),
        fullWidth: true,
        suffix: "%",
        value: this.state.dental || 0,
        onChange: function onChange(e) {
          return _this2._handleChange("dental", e.target.value);
        },
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].titles.health),
        fullWidth: true,
        suffix: "%",
        value: this.state.health || 0,
        onChange: function onChange(e) {
          return _this2._handleChange("health", e.target.value);
        },
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].titles.outOfCountry),
        fullWidth: true,
        suffix: "%",
        value: this.state.outOfCountry || 0,
        onChange: function onChange(e) {
          return _this2._handleChange("outOfCountry", e.target.value);
        },
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].titles.stopLoss),
        fullWidth: true,
        suffix: "%",
        value: this.state.stopLoss || 0,
        onChange: function onChange(e) {
          return _this2._handleChange("stopLoss", e.target.value);
        },
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].titles.healthSpending),
        fullWidth: true,
        suffix: "%",
        value: this.state.hsa || 0,
        onChange: function onChange(e) {
          return _this2._handleChange("hsa", e.target.value);
        },
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].titles.lifestyleSpending),
        fullWidth: true,
        suffix: "%",
        value: this.state.lsa || 0,
        onChange: function onChange(e) {
          return _this2._handleChange("lsa", e.target.value);
        },
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].titles.employeeAssistance),
        fullWidth: true,
        suffix: "%",
        value: this.state.efap || 0,
        onChange: function onChange(e) {
          return _this2._handleChange("efap", e.target.value);
        },
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 3
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].titles.virtualHealthCare),
        fullWidth: true,
        suffix: "%",
        value: this.state.virtualHealthcare || 0,
        onChange: function onChange(e) {
          return _this2._handleChange("virtualHealthcare", e.target.value);
        },
        variant: "outlined"
      }))), (this.props.isMasterSite || this.props.currentAccountMeta.state <= 3) && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          if (!_this2.props.isQuote && !_this2.props.isRevision && _this2.props.isMasterSite) {
            _this2._toggleEffectiveDateDialog();
          } else {
            _this2._save();
          }
        },
        color: "primary",
        customStyle: {
          display: 'block',
          marginLeft: 'auto'
        }
      }, _i18n["default"].t(_tokens["default"].buttons.saveCommissions))), /*#__PURE__*/_react["default"].createElement(_StepCompletionNotif["default"], {
        dialog: _i18n["default"].t(_tokens["default"].labels.advisor.successfulSubmissionMessage),
        type: "Commissions",
        open: this.state.successDialogOpen,
        handleClose: this._closeSuccessDialog,
        handleNext: this._goToNextStep,
        disableBackdropClick: true,
        disableEscapeKeyDown: true
      }), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showEffectiveDateDialog,
        close: this._toggleEffectiveDateDialog,
        title: _i18n["default"].t(_tokens["default"].titles.setEffectiveDate),
        onSave: this._save,
        saveButtonText: _i18n["default"].t(_tokens["default"].buttons.submit)
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, _i18n["default"].t(_tokens["default"].labels.pleaseProvideEffectiveDate)), /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.effectiveDate),
        value: this.state.effectiveDate,
        onChange: function onChange(e) {
          _this2.setState({
            effectiveDate: e.target.value
          });
        },
        error: Boolean(this.state.effectiveDateError),
        helperText: this.state.effectiveDateError,
        fullWidth: true,
        required: true
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        margin: "10px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.advisor.changesAppliedOnEffectiveDate)), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel,
        customImageStyle: {
          top: '50%'
        }
      })), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel
      }));
    }
  }]);
  return CommissionsForm;
}(_react.Component);
var _default = exports["default"] = CommissionsForm;